import { configureEmojiAssets } from '@affine/component/emoji-asset';

__webpack_public_path__ = environment.publicPath;

// Emoji artwork is served from the app's public assets; resolve it relative
// to the deploy public path (sub-path deployments, CDN, electron).
configureEmojiAssets(`${environment.publicPath}emoji/apple/64/`);
